export default "__VITE_ASSET__JmICsxyG__"